import Rive, {Layout} from "rive-react";
import bgRiv from "../../assets/img/background/bg_sekilas_gemilang.riv";
import Moment from "moment";
import React, {useEffect, useRef, useState} from "react";
import {postDanai} from "../util/ajax";
import {formatNumberToIndonesian, numberWithSeparator} from "../util/common";

export default function StatistikDanai(){
    const [totalAkumulasiPinjamanSejakBerdiri, setTotalAkumulasiPinjamanSejakBerdiri] = useState("-")
    const [totalAkumulasiPinjamanSepanjangTahunBerjalan, setTotalAkumulasiPinjamanSepanjangTahunBerjalan] = useState("-")
    const [totalOutstandingPinjaman, setTotalOutstandingPinjaman] = useState("-")
    const [tkb90, setTkb90] = useState("-")
    const [totalBorrowerIndividual, setTotalBorrowerIndividual] = useState("-")
    const [totalBorrowerInstitusi, setTotalBorrowerInstitusi] = useState("-")
    const [totalBorrowerIndividualAktif, setTotalBorrowerIndividualAktif] = useState("-")
    const [totalBorrowerInstitusiAktif, setTotalBorrowerInstitusiAktif] = useState("-")
    const [totalLender, setTotalLender] = useState("-")
    const [totalLenderAktif, setTotalLenderAktif] = useState("-")
    const [dateUpdated, setDateUpdated] = useState("-")

    useEffect(() => {
        postDanai(process.env.REACT_APP_MOBILE_API_URL + '/p2p-mobile-api/rest/customerWeb/statistic', function (resp) {
            setTotalAkumulasiPinjamanSejakBerdiri(formatNumberToIndonesian(resp.totalAkumulasiPinjamanSejakBerdiri));
            setTotalAkumulasiPinjamanSepanjangTahunBerjalan(formatNumberToIndonesian(resp.totalAkumulasiPinjamanSepanjangTahunBerjalan));
            setTotalOutstandingPinjaman(formatNumberToIndonesian(resp.totalOutstandingPinjaman));
            setTkb90(resp.tkb90);
            setTotalBorrowerIndividual(numberWithSeparator(resp.totalBorrowerIndividual));
            setTotalBorrowerInstitusi(numberWithSeparator(resp.totalBorrowerInstitusi));
            setTotalBorrowerIndividualAktif(numberWithSeparator(resp.totalBorrowerIndividualAktif));
            setTotalBorrowerInstitusiAktif(numberWithSeparator(resp.totalBorrowerInstitusiAktif));
            setTotalLender(numberWithSeparator(resp.totalLender));
            setTotalLenderAktif(numberWithSeparator(resp.totalLenderAktif));
            setDateUpdated(resp.id);
            console.log(resp);
        }, function () {

        });
    }, []);

    const containerRef = useRef(null);
    const [height, setHeight] = useState("100vh"); // Default to viewport height

    useEffect(() => {
        const updateHeight = () => {
            if (containerRef.current) {
                setHeight(containerRef.current.clientHeight + "px"); // Ensure it matches the container height
            }
        };

        updateHeight(); // Initial height set
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);
    return (
        <div ref={containerRef} className="container-2">
            <div className="rive-background" style={{height}}>
                <Rive
                    src={bgRiv}
                    layout={new Layout({fit: "cover", alignment: "center"})}
                    style={{width: "100%", height: "100%"}}
                />
            </div>
            <div className="section-title text-center relative z-1" id='informasi-statistik'>
                <h2 className="text-header">Sekilas Gemilang <span>Danai.id</span></h2>
                <p>Mengamati pencapaian dan performa yang telah dicapai melalui inovasi hingga saat ini.</p>
            </div>
            <div className="bento-grid relative z-1">
                <div className="bento top">
                    <div className="bento-item item1">
                        <div className="title">{tkb90}%</div>
                        <p>Tingkat Keberhasilan 90</p>
                    </div>
                    <div className="bento-item item2">
                        <div className="title">Rp {totalAkumulasiPinjamanSejakBerdiri}</div>
                        <p>Akumulasi Pinjaman Sejak Berdiri</p>
                    </div>
                    <div className="bento-item item3">
                        <div className="title">Rp {totalAkumulasiPinjamanSepanjangTahunBerjalan}</div>
                        <p>Akumulasi Pinjaman Sepanjang Tahun Berjalan</p>
                    </div>
                    <div className="bento-item item4">
                        <div className="title">Rp {totalOutstandingPinjaman}</div>
                        <p>Outstanding Pinjaman</p>
                    </div>

                </div>
                <div className="bento bottom">
                    <div className="bento-item item5">
                        <div className="title">{totalBorrowerIndividual}</div>
                        <p>Penerima Dana Individual</p>
                    </div>
                    <div className="bento-item item6">
                        <div className="title">{totalBorrowerIndividualAktif}</div>
                        <p>Penerima Dana Individual Aktif</p>
                    </div>
                    <div className="bento-item item7">
                        <div className="title">{totalBorrowerInstitusi}</div>
                        <p>Penerima Dana Institusi</p>
                    </div>
                    <div className="bento-item item8">
                        <div className="title">{totalBorrowerInstitusiAktif}</div>
                        <p>Penerima Dana Institusi Aktif</p>
                    </div>
                    <div className="bento-item item9">
                        <div className="title">{totalLender}</div>
                        <p>Pemberi Dana</p>
                    </div>
                    <div className="bento-item item10">
                        <div className="title">{totalLenderAktif}</div>
                        <p>Pemberi Dana Aktif</p>
                    </div>
                </div>
                <p id="desc">*Data diambil per tanggal <span
                    id="stat-date">{Moment(dateUpdated).format('DD MMMM yyyy')}</span></p>
            </div>
        </div>
    );
}